<div class="container">
  <div class="video-grid">
    @for (p of videoParticipants; track p) {
      <div class="tile"><img [src]="p" /></div>
    }
  </div>
  <div class="remote-control">
    @if (contentEnabled) {
      <div
        class="buttons flex justify-center align-items-center"
        [hidden]="!remoteEnabled"
      >
        <!-- TODO icon: review skip_previous/skip_next — using chevron-left/chevron-right as closest matches -->
        <ut-button variant="ghost" iconOnly iconLeft="chevron-left"></ut-button>
        <ut-button variant="ghost" iconOnly iconLeft="chevron-left"></ut-button>
        <ut-button variant="ghost" iconOnly iconLeft="chevron-right"></ut-button>
      </div>
    }
    @if (contentEnabled) {
      <!-- TODO icon: review settings_remote — using 'settings' as closest match -->
      <ut-icon name="settings" class="remote" (click)="remoteToggle()"></ut-icon>
    }
    <ut-icon [name]="mediaIcon" class="mediaswitch" (click)="mediaSwitchToggle()"></ut-icon>
  </div>
</div>
